import { get, post } from '@/services/http';
import { InventoryLocationSettingModel } from '@/models/inventory_location_setting';
import List from './list';

export class InventoryLocationSettingList extends List<InventoryLocationSettingModel> {
  public async fetch() {
    const res: any = await get(`/inventory-location-settings`, {});
    const settings = res || [];
    this.items = []; // Clear existing items
    for (const data of settings) {
      this.add(new InventoryLocationSettingModel(data));
    }
  }

  public async save() {
    const dirtySettings = this.items
      .filter((item) => item.isDirty)
      .map((item) => item.toJSON());

    if (dirtySettings.length === 0) {
      return; // Nothing to save
    }

    const res: any = await post('/inventory-location-settings', {
      settings: dirtySettings,
    });
    const updatedSettings = res.data.settings || [];

    // Update the models with the response from the server
    for (const updated of updatedSettings) {
      const model = this.items.find((item) => item.id === updated.id);
      if (model) {
        // Re-create the model to reset dirty state
        const index = this.items.indexOf(model);
        this.items[index] = new InventoryLocationSettingModel(updated);
      }
    }
  }
}
